// K4 (decision 15 Oct 2026): a wrong digit in a translated helpline number
// is the one translation error that could really hurt. Before saving the
// safety-net message, compare the phone numbers, web and email addresses and
// room numbers across the language versions and warn when one is missing
// from a version. A warning only; nothing is blocked.

const PHONE = /(?:\+?\d[\d\s-]{5,}\d)/g;
const WEB = /\b(?:https?:\/\/)?(?:[a-z0-9-]+\.)+[a-z]{2,}(?:\/[^\s,;)]*)?/gi;
const ROOM = /\b[A-Z]?\d{2,4}[A-Z]?\b/g;

function tokens(text: string): Set<string> {
  const out = new Set<string>();
  for (const m of text.match(PHONE) ?? []) {
    const digits = m.replace(/[^\d+]/g, '');
    if (digits.replace('+', '').length >= 6) out.add(digits);
  }
  for (const m of text.match(WEB) ?? []) out.add(m.toLowerCase().replace(/^https?:\/\//, '').replace(/\/$/, ''));
  // Room numbers and short codes, ignoring the parts of phone numbers.
  const noPhones = text.replace(PHONE, ' ');
  for (const m of noPhones.match(ROOM) ?? []) out.add(m.toUpperCase());
  return out;
}

/** Details that appear in some written language versions but not all. */
export function contactMismatches(texts: Record<string, string>): string[] {
  const written = Object.values(texts).filter((v) => v.trim() !== '');
  if (written.length < 2) return [];
  const sets = written.map(tokens);
  const all = new Set<string>();
  sets.forEach((s) => s.forEach((x) => all.add(x)));
  return [...all].filter((x) => sets.some((s) => !s.has(x))).sort();
}
